import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '../ui/tooltip';

const CustomTooltip = ({ children, text, shortcutIcon: Icon = null, shortcutText = null, open, onOpenChange }) => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip open={open} onOpenChange={onOpenChange}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side="top" className="z-[9999]" disableHoverableContent={false}>
          <p className="flex flex-row items-center justify-center gap-2">
            {text}
            {(Icon || shortcutText) && (
              <div className="bg-[var(--q3-surface-default)] text-[var(--q3-neutral-default)] p-1 rounded">
                {Icon ? <Icon /> : shortcutText}
              </div>
            )}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CustomTooltip;
